export const isAdmin = (location: any) =>
  Boolean(location && location.pathname.includes('/staff/'));
